import styled from 'styled-components';

interface IProps {
  color: string;
  borderColor?: string;
  borderStyle?: string;
}

export const ColorDot = styled.div<IProps>`
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${(props: IProps): string => props.color};
  border-style: ${(props: IProps): string => props.borderStyle ?? 'solid'};
  border-color: ${(props: IProps): string =>
    props.borderColor ?? 'transparent'};
`;
